import JobDetails from '../components/JobDetails';
export default JobDetails; 